/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Injectable} from '@angular/core';
import {map, Observable} from 'rxjs';

import {ApiConfig} from '../config/api-config';
import {AdnApiClientService} from '../common/controller/adn-api-client.service';

@Injectable({providedIn: 'root'})
export class DeviceApiService {
  constructor(private readonly client: AdnApiClientService, private readonly apiConfig: ApiConfig) {
  }

  getProperties(): Observable<Record<string, string[]>> {
    return this.client.request<{results: Array<{group: string; properties: Array<{value: string}>}>}>({
      method: 'GET',
      url: this.apiConfig.getVersionedUri('devices'),
      params: {context: null}
    }).pipe(map((page) => {
      const properties: Record<string, string[]> = {};
      for (const group of page.results || []) {
        properties[group.group] = (group.properties || []).map((property) => property.value).sort();
      }
      return properties;
    }));
  }
}
